const AUTHENTICATION = "authentication";

export { AUTHENTICATION };
